import { useMarketRoute } from '../../../hooks/useMarketRoute';
import { useEffect } from 'react';
import { bridge, isApp } from 'shared/src/utils';

export const useReportTTFD = () => {
  const { params } = useMarketRoute<'MarketHome'>();

  useEffect(() => {
    if (!params.instanceId) {
      return;
    }
    if (isApp()) {
      bridge.reportTTFD({ instanceId: params.instanceId });
    }
  }, [params.instanceId]);
};
